export enum WalletRoutesEnum {
  WALLET = 'wallet',
  TOPUP = 'wallet-topup',
}
